import { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, Button, TextField, Modal, IconButton } from '@material-ui/core';
import { Edit, Delete } from '@material-ui/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from '../../../Components/Dashboard';
import Denied from '../../../Components/Denied';
import { store } from '../../../store';
import history from '../../../Services/history';
import { SubmitButton } from '../../../Components/Custom';
import stylePagesEmbalei from '../style';
import { apiEmbalei, apiLabs } from '../../../Services/api';

function UserEmbalei(props) {
  const style = stylePagesEmbalei();
  const { location: { idPage } } = props;
  const [auth, setAuth] = useState(null);
  const [users, setUsers] = useState([]);
  const [username, setUsername] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  async function verifyAuth() {
    const { profile } = store.getState().user;
    const res = await apiLabs.post('valid_key', { id: profile.id, menu_id: idPage });
    if (res.data.message === "User not authorized") {
      return setAuth('denied');
    }
    if (res.data.message === "User authorized") {
      return setAuth('authorized');
    }
    return history.push({ pathname: '/', state: { from: props.location } });
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setUsername('');
    setBirthdate('');
  };

  const handleEditOpen = (user) => {
    setCurrentUser(user);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setCurrentUser(null);
  };

  const handleConfirmDeleteOpen = (user) => {
    setCurrentUser(user);
    setConfirmDeleteOpen(true);
  };

  const handleConfirmDeleteClose = () => {
    setConfirmDeleteOpen(false);
    setCurrentUser(null);
  };

  async function fetchUsers() {
    try {
      const response = await apiEmbalei.get('/user');
      setUsers(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if (birthdate.length !== 8) {
      toast.error('Data de aniversário incompleta');
      return;
    }
    if (users.some(user => user.username === username)) {
      toast.error('Nome de usuário já existe');
      return;
    }
    try {
      const response = await apiEmbalei.post('/user', { username, password: birthdate.replace(/\D/g, '') });
      toast.success(`Usuário ${response.data.username} criado com sucesso!`);
      fetchUsers();
      handleClose();
    } catch (error) {
      console.error(error);
      toast.error('Erro ao criar usuário');
    }
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    try {
      const response = await apiEmbalei.put(`/user/${currentUser.id}`, { username: currentUser.username.toUpperCase() });
      toast.success(`Usuário ${response.data.username} atualizado com sucesso!`);
      fetchUsers();
      handleEditClose();
    } catch (error) {
      console.error(error);
      toast.error('Erro ao atualizar usuário');
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await apiEmbalei.delete(`/user/${id}`);
      toast.success('Usuário excluído com sucesso!');
      fetchUsers();
      handleEditClose();
      handleConfirmDeleteClose();
    } catch (error) {
      console.error(error);
      toast.error('Erro ao excluir usuário');
    }
  };

  const handleBirthdateChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
    if (value.length > 6) {
      value = value.slice(0, 6); // Limita o comprimento a 6 caracteres
    }

    // Adiciona a formatação de data
    if (value.length > 2) {
      value = value.slice(0, 2) + '/' + value.slice(2);
    }
    if (value.length > 5) {
      value = value.slice(0, 5) + '/' + value.slice(5);
    }

    setBirthdate(value);
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value.toUpperCase());
  };

  const handleEditUsernameChange = (e) => {
    setCurrentUser({ ...currentUser, username: e.target.value.toUpperCase() });
  };

  useEffect(() => {
    fetchUsers();
    verifyAuth();
  }, []);

  return (
    <Dashboard title="Usuários Embalei" className={style.root}>
      {auth === 'denied' && <Denied />}
      {auth === 'authorized' && (
        <Container maxWidth='md'>
          <ToastContainer />
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography className={style.titlePage}>Usuários Criados</Typography>
              <Button variant="contained" color="secondary" onClick={handleOpen}>
                Criar Usuário
              </Button>
            </Grid>
            <Grid item xs={12}>
              <table className={style.tableEmbalei} border={0} cellSpacing={0} style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th style={{ width: '20%' }}>Código do Usuário</th>
                    <th style={{ width: '60%' }}>Usuário</th>
                    <th style={{ width: '20%' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id}>
                      <td>{user.id}</td>
                      <td>{user.username}</td>
                      <td style={{ textAlign: 'center' }}>
                        <IconButton onClick={() => handleEditOpen(user)}>
                          <Edit />
                        </IconButton>
                        <IconButton onClick={() => handleConfirmDeleteOpen(user)}>
                          <Delete />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Grid>
          </Grid>
          <Modal open={open} onClose={handleClose}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 24,
              p: 4,
            }}>
              <Typography variant="h6" component="h2">
                Criar Usuário
              </Typography>
              <form onSubmit={handleCreateUser} className={style.formContainer}>
                <TextField
                  className={style.formField}
                  fullWidth
                  variant="outlined"
                  label="Nome do Usuário"
                  value={username}
                  onChange={handleUsernameChange}
                  required
                />
                <TextField
                  className={style.formField}
                  fullWidth
                  variant="outlined"
                  label="Data do Aniversário"
                  value={birthdate}
                  onChange={handleBirthdateChange}
                  inputProps={{ maxLength: 8 }}
                  required
                />
                <SubmitButton className='no-margin' type='submit'>Criar</SubmitButton>
              </form>
            </Box>
          </Modal>
          <Modal open={editOpen} onClose={handleEditClose}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 24,
              p: 4,
            }}>
              <Typography variant="h6" component="h2">
                Editar Usuário
              </Typography>
              <form onSubmit={handleUpdateUser} className={style.formContainer}>
                <TextField
                  className={style.formField}
                  fullWidth
                  variant="outlined"
                  label="Nome do Usuário"
                  value={currentUser?.username || ''}
                  onChange={handleEditUsernameChange}
                  required
                />
                <SubmitButton className='no-margin' type='submit' style={{ marginTop: '16px' }}>
                  Salvar Alterações
                </SubmitButton>
              </form>
            </Box>
          </Modal>
          <Modal open={confirmDeleteOpen} onClose={handleConfirmDeleteClose}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 24,
              p: 4,
            }}>
              <Typography variant="h6" component="h2" style={{ marginTop: 8 }}>
                Confirmar Exclusão
              </Typography>
              <Typography>
                Tem certeza que deseja excluir o usuário {currentUser?.username}?
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 24 }}>
                <Button variant="contained" color="secondary" onClick={() => handleDeleteUser(currentUser?.id)}>
                  Confirmar
                </Button>
                <Button variant="contained" onClick={handleConfirmDeleteClose}>
                  Cancelar
                </Button>
              </Box>
            </Box>
          </Modal>
        </Container>
      )}
    </Dashboard>
  );
}

export default UserEmbalei;
